import { getPageIdInfo, getQuery } from "../../utils/common";
import Pagelife from "../../lego-pagelife";
import lego from "../../lego";
import Logger from "../../utils/log";
var sendData = function sendData(obj) {
  lego.send(obj);
};
var setLegoStayTimeInfo = function setLegoStayTimeInfo(duration) {
  var _ref, _getQuery;
  var pageInfo = getPageIdInfo();
  var infoid = (_ref = (_getQuery = getQuery('infoId')) !== null && _getQuery !== void 0 ? _getQuery : getQuery('infoid')) !== null && _ref !== void 0 ? _ref : '';
  var base = {
    pagetype: 'LengthOfStay',
    actiontype: (pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.pageId) || 'noPageId',
    backup: {
      infoid: infoid,
      url: location.href,
      eventduration: duration,
      subpageID: window['zz_lego_backup'].subpageID || null
    }
  };
  localStorage.setItem('lego-stay-time-info', JSON.stringify(base));
};
var sendLegoStayTimeInfo = function sendLegoStayTimeInfo() {
  var info = localStorage.getItem('lego-stay-time-info');
  localStorage.removeItem('lego-stay-time-info');
  if (info) {
    var _sendItem$backup;
    var sendItem = JSON.parse(info);
    if ((sendItem === null || sendItem === void 0 || (_sendItem$backup = sendItem.backup) === null || _sendItem$backup === void 0 ? void 0 : _sendItem$backup.eventduration) !== 0) {
      sendData(sendItem);
    }
  }
};
var calcUserStayTimeInit = function calcUserStayTimeInit() {
  Logger.info('已开启用户停留时间插件');
  var startTime;
  var timer;
  Pagelife.add('onShow', function () {
    sendLegoStayTimeInfo();
    setLegoStayTimeInfo(0);
    startTime = performance.now();
    timer = setInterval(function () {
      var elapsedTime = ((performance.now() - startTime) / 1000).toFixed(2);
      setLegoStayTimeInfo(elapsedTime);
    }, 1000);
  });
  Pagelife.add('onHide', function () {
    clearInterval(timer);
    setLegoStayTimeInfo(((performance.now() - startTime) / 1000).toFixed(2));
    sendLegoStayTimeInfo();
  });
};
export default calcUserStayTimeInit;